<template>
  <div v-if="shouldRenderConfig" :class="getClassName">
    <div>
      {{ $t("PDF DIE-CUT TEMPLATE") }}
    </div>
    <appPreview2D visible="visible"></appPreview2D>
    <appDownloadCF2Button></appDownloadCF2Button>
    <appDownloadPDFButton></appDownloadPDFButton>
  </div>
</template>
<script>
import { useCostCenterStore } from "@/stores/modules/costCenter";
import { mapState, mapActions } from "pinia";

export default {
  computed: {
    ...mapState(useCostCenterStore, ["getCostCenter"]),
    name: () => {
      return "Cost Center Number:";
    },
    costCenter: {
      get: function () {
        return this.getCostCenter;
      },
      set: function (newValue) {
        this.setCostCenter(newValue);
      }
    }
  },
  methods: { ...mapActions(useCostCenterStore, ["setCostCenter"]) }
};
</script>
